import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import { BaseApiResponse } from '../../../../api/shared'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'
import {
  deleteJiraCredential,
  DeleteJiraCredentialArgs
} from './requests/delete-jira-credential'
import { toast } from '@contrast-security-inc/design-system-alerts'

import { getErrorMsg } from '../../../application-exclusions/shared'

export interface UseDeleteCredentialQueryProps {
  organizationUuid: string
  credentialId: string
  isEnabled: boolean
  successCallback: () => void
  errorCallback: () => void
}

export interface UseDeleteCredentialQueryResponse {
  data: BaseApiResponse
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseDeleteCredentialQuery = (
  props: UseDeleteCredentialQueryProps
) => UseDeleteCredentialQueryResponse

export const useDeleteCredentialQuery: UseDeleteCredentialQuery = ({
  organizationUuid,
  credentialId,
  isEnabled,
  successCallback,
  errorCallback
}: UseDeleteCredentialQueryProps) => {
  const { data, error, isError, isLoading } = useContrastQuery<
    DeleteJiraCredentialArgs,
    any
  >(
    [Query.INTEGRATIONS_DELETE_JIRA_CREDENTIAL, organizationUuid, credentialId],
    deleteJiraCredential,
    {
      organizationUuid,
      credentialId
    },
    {
      enabled: !!credentialId && isEnabled,
      onSuccess: successCallback,
      onError: ({ data: { messages } }) => {
        toast(getErrorMsg(messages), {
          variant: 'error'
        })
        errorCallback()
      }
    }
  )

  return {
    data,
    error,
    isError,
    isLoading
  }
}
